import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { AppState } from 'src/app/@store/app.reducers';
import { selectDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { MatPaginator } from '@angular/material/paginator';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-modal-ver-referencias-siniestro-resumen',
    templateUrl: './modal-ver-referencias-siniestro-resumen.component.html',
    styleUrls: ['./modal-ver-referencias-siniestro-resumen.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, NgClass, MatPaginator]
})
export class ModalVerReferenciasSiniestroResumenComponent {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  public datosReferencias = new MatTableDataSource([]);
  public displayColumns = ['Banco', 'Referencia'];
  private listaObservables = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<ModalVerReferenciasSiniestroResumenComponent>,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: { tipoCliente: number, numeroLiga : string },
    private complementoWebService: ComplementoWebService,
    private procesosComunesService: ProcesosComunesComplementoService,
  ) {
    this.obtenerReduxState();
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleSiniestro]) => {
      // this.detalleSiniestro = { ...detalleSiniestro };
      this.consultarReferenciasRecuperaciones(siniestro);
    });
    this.listaObservables.add(subsComplemento);
  }

  closeDialog(opcion: string) {
    if (opcion == 'Cancelar') this.dialogRef.close();
    if (opcion == 'Aceptar') this.dialogRef.close();
  }

  consultarReferenciasRecuperaciones(siniestro: string) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(siniestro);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      numeroLiga: this.data.numeroLiga,
      tipoCliente: this.data?.tipoCliente ?? 2, //REVIEW - 
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaRecuperacionesPagosReferencias(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado.Referencias.length) {
          this.datosReferencias = new MatTableDataSource(value.Resultado.Referencias);
          this.datosReferencias.paginator = this.paginator;
        } else {
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de los lesionados.' }));
      },
    })
  }
}
